import type { QueryClient, QueryKey } from '@tanstack/react-query'

/**
 * Mark the shared overview stale after an authoritative create response
 * without starting another overview request in the same mutation.
 */
export function markOverviewStaleAfterFolderCreation(
  queryClient: QueryClient,
  queryKey: QueryKey,
): Promise<void> {
  return queryClient.invalidateQueries({ queryKey, refetchType: 'none' })
}
